import React, { ReactElement, useContext } from 'react'
import { countryShortLabel } from '../helpers/countries'
import PersonMetadata from './PersonMetadata'
import { PersonContext } from '../contexts/PersonContext'
import { useNavigate } from 'react-router-dom'

const PersonThumbnail = (props: { personId: number }): ReactElement => {
    const { state } = useContext(PersonContext)
    const navigate = useNavigate()
    const onClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
        // eslint-disable-next-line dot-notation
        if (event.target['classList'].contains('person-thumbnail-link')) {
            void navigate('/person/' + props.personId)
        }
    }

    const person = state.people?.[props.personId]
    if (!person) {
        console.error('Displaying a PersonThumbnail without relevant state')
        return <></>
    }
    return <div className="thumbnail person-thumbnail person-thumbnail-link thumbnail-link" onClick={ onClick }>
        <h3 className="person-thumbnail-title person-thumbnail-link thumbnail-link">
            {person.name}
            {person.country && <span className="person-country"> {countryShortLabel(person.country)}</span>}
        </h3>
        <PersonMetadata person={ person } />
    </div>
}

export default PersonThumbnail
